import React, { Component } from 'react';
import '../App.css';

class EndScreen extends Component {

constructor() {
	super();
	this.state = { winnerColor:'black'};
}

componentDidMount() {
  this.playAgain();
  //this.colorWinner();
}

colorWinner() {

  if (this.props.winner==='Blue') {
      this.setState((state)=>{winnerColor: state.winnerColor = '#4ed6ff'});
      console.log("I ork");
      console.log(this.state.winnerColor);
    }
  else if (this.props.winner==="Pink") {
      this.setState((state)=>{winnerColor: state.winnerColor = '#4ed6ff'});
      console.log("I ork");
      console.log(this.state.winnerColor);
    }
}

playAgain() {

  let playAgainButton = document.getElementById('playAgain');

  setTimeout(()=>{
    playAgainButton.style.transform='scale(.7)';
  }, 500);

  playAgainButton.classList.add('pulse');
}

  render() {

    var userScore1 = 0;
    var userScore2 = 0;

    if (this.props.winner === 'Blue') {
      userScore1 += this.props.wScore;
      userScore2 += this.props.lScore;
    }
    else if (this.props.winner === 'Pink') {
      userScore2 += this.props.wScore;
      userScore1 += this.props.lScore;
    }
    else {
      userScore2 += this.props.tScore;
      userScore1 += this.props.tScore;
    }

    var color;

    if (this.props.winner==='Blue') {
      color='#4ed6ff';
    }
  else if (this.props.winner==="Pink") {
      color='#ff7fef';
    }

    return (
      <div className="titleScreen full">
      {this.props.tie === true? (
      		<div>
      		<h1 className="endSpin tie"> Tie!</h1>
	      	</div>)
	    : (
	      	<div>
	      	  <h1 className="endSpin" style={{color:color }}>{this.props.winner} Wins!</h1>
	      	</div>
      	)}

        <button id="playAgain" onClick={this.props.reset}>Play Again!</button>

        <div className="scoreViewEnd">
          <span className="userScore" id="score1">
            <h1 className="score">{userScore1} </h1>
          </span>
          <span className="userScore" id="score2">
            <h1 className="score">{userScore2} </h1>
          </span>
      </div>
      </div>
    );
  }
}

export default EndScreen;



// WEBPACK FOOTER //
// ./src/components/EndScreen.js